<i18n src="./resources/locales.json"></i18n>

<template>
  <EcsSideBarWrapper v-resize="onResize" :search-placeholder="$t('placeholder')" @search-input-changed="handleSearch">
    <v-row no-gutters>
      <!-- Pending interactions -->
      <EcsSideBarInteractionList
        v-if="displayPendingInteraction"
        id="ecs-pending-interactions-list"
        :header="$t('header.pendingInteractions')"
        :interactions="getPendingInteractions"
        :max-height="pendingInteractionsContainerHeight"
        is-pending
        show-counter
        hide-load-more
      />

      <!--Opened SMS-->
      <EcsSideBarInteractionList
        v-show="filteredItems.activeInteractions.length"
        :header="$t('header.opened')"
        :interactions="filteredItems.activeInteractions"
        :max-height="activeInteractionsContainerHeight"
        show-counter
        hide-load-more
      />

      <!--SMS History-->
      <EcsSideBarInteractionList
        v-show="filteredItems.historicInteractions.length"
        :header="$t('header.smsHistory')"
        :interactions="filteredItems.historicInteractions"
        :max-height="historicInteractionsContainerHeight"
      />

      <!-- Empty History Section -->
      <EcsSideBarTileContent v-if="showTileContent" :header="$t('header.smsHistory')">
        <div class="empty-interaction-history-section pa-2 mx-4">
          <span v-once>
            {{ $t('body.nothing_here') }}
          </span>
          <br />
          <span v-once>
            {{ $t('body.make_history') }}
          </span>
        </div>

        <SideBarLoadMoreBtn v-if="showTileContent" />
      </EcsSideBarTileContent>
    </v-row>
  </EcsSideBarWrapper>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import EcsSideBarInteractionMixins from '@/mixins/ecs-side-bar-interaction-mixins/EcsSideBarInteractionMixins';
import SideBarLoadMoreBtn from '@/components/ecs-app-side-bar/ecs-side-bar-interaction-item/side-bar-load-more-btn/SideBarLoadMoreBtn';

export default {
  name: 'EcsSmsSideBar',

  components: { SideBarLoadMoreBtn },

  mixins: [EcsSideBarInteractionMixins],

  computed: {
    ...mapGetters('INTERACTIONS', ['getHistoricalSmsInteractions', 'getActiveSmsInteractions']),

    ...mapGetters('SETTINGS', ['currentUserSettings']),

    filteredItems() {
      const activeInteractions = this.filterItems(this.getActiveSmsInteractions);
      const historicInteractions = this.filterItems(this.getHistoricalSms());

      return {
        activeInteractions,
        historicInteractions
      };
    },

    showTileContent() {
      return !this.filteredItems.historicInteractions.length;
    }
  },

  methods: {
    getHistoricalSms() {
      const currentDate = moment();
      // Converting the interaction history period to seconds to have precision in validation the timestamp
      const currentPeriodSetting =
        (this.currentUserSettings.preferencesSettings.interactionHistoryPeriod / 24) * 24 * 3600;
      return this.getHistoricalSmsInteractions.filter(
        interaction =>
          interaction.destinationContact.endPoint !== null &&
          currentDate.diff(moment(interaction.timestamp), 'seconds') <= currentPeriodSetting
      );
    },
    getAdditionalSerchableAttributes(item) {
      return '';
    }
  }
};
</script>

<style scoped></style>
